import { useContext } from 'react';
import PatientEnrollmentOptionsContext from './PatientEnrollmentContext';

const usePatientEnrollmentOptions = () => useContext(PatientEnrollmentOptionsContext);

export default usePatientEnrollmentOptions;
